import { client } from "@/client";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

type CurrencyData = {
  code: string;
  name: string;
  name_plural: string;
  decimal_digits: number;
  rounding: number;
  symbol: string;
  symbol_native: string;
};

export type CurrencyList = { [key: string]: CurrencyData };

export const useCurrency = () => {
  const userDetails = useQuery(client.users.me.asQueryOptions());
  const response = useQuery(client.currency.getCurrencyList.asQueryOptions());

  return useMemo(() => {
    let userCurrency: string | null | undefined = null;
    let currencyName: string | null | undefined = null;
    if (!response.data || !userDetails.data?.currency) {
      return { userCurrency, currencyName };
    }
    const currencyList = response.data as CurrencyList;
    userCurrency =
      currencyList[userDetails.data.currency]?.name +
      " - " +
      currencyList[userDetails.data.currency]?.code +
      " - " +
      currencyList[userDetails.data.currency]?.symbol;

    const currencyOptions = Object.entries(currencyList).map(
      ([key, value]) => ({
        label: `${value?.name} - ${key} - ${value?.symbol_native}`,
        value: key,
      }),
    );

    const currencySymbol = currencyList[userDetails.data.currency]?.symbol;
    currencyName = currencyList[userDetails.data.currency]?.name;

    return {
      userCurrency,
      currencyOptions,
      currencySymbol,
      currencyName,
    };
  }, [response, userDetails]);
};

type WeightData = {
  code: string;
  name: string;
  name_plural: string;
  symbol: string;
  symbol_native: string;
};

const defautltWeightData: WeightData = {
  code: "grams",
  name: "Grams",
  name_plural: "Grams",
  symbol: "g",
  symbol_native: "g",
};

export const useWeight = () => {
  const userDetails = useQuery(client.users.me.asQueryOptions());
  return (
    (userDetails?.data as unknown as { weight: WeightData })?.weight ??
    defautltWeightData
  ); // #TODO: implement weight units per account
};
